import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var ZIndex = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(ZIndex, _ValueWithRandom);
  var _super = _createSuper(ZIndex);
  function ZIndex() {
    var _this;
    _classCallCheck(this, ZIndex);
    _this = _super.call(this);
    _this.opacityRate = 1;
    _this.sizeRate = 1;
    _this.velocityRate = 1;
    return _this;
  }
  _createClass(ZIndex, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(ZIndex.prototype), "load", this).call(this, data);
      if (!data) {
        return;
      }
      if (data.opacityRate !== undefined) {
        this.opacityRate = data.opacityRate;
      }
      if (data.sizeRate !== undefined) {
        this.sizeRate = data.sizeRate;
      }
      if (data.velocityRate !== undefined) {
        this.velocityRate = data.velocityRate;
      }
    }
  }]);
  return ZIndex;
}(ValueWithRandom);